import './ReviewChanges.scss';
import {Checkbox} from "antd";
import {Button} from "../account/misc/Button";
import {useState} from "react";
import {ToastDeltaUpdate} from "../../generated/dashboard-client";

export interface ReviewChangesProps {
  updates: ToastDeltaUpdate[];
  onApprove: (ids: string[]) => void;
}

export default function ReviewChanges({updates, onApprove}: ReviewChangesProps) {
  const [selected, setSelected] = useState([] as string[]);

  async function approveSelected() {
    onApprove(selected);
  }

  async function approveAll() {
    onApprove(updates.map(it => it.id!!));
  }

  function toggleSelected(id: string) {
    if (selected.find(s => s === id)) {
      setSelected(selected.filter(it => it !== id));
    } else {
      setSelected([...selected, id]);
    }
  }

  function formatPrice(price: string | number | undefined) {
    return `$${parseFloat(`${price}`).toFixed(2)}`;
  }

  function getPrice(d: ToastDeltaUpdate) {
    try {
      const multiplePrices = JSON.parse(d.itemPriceMultipleJson || '[]') as any[];
      if (multiplePrices.length) {
        const obj = {} as { [key: string]: string };
        multiplePrices.forEach(it => {
          const key = Object.keys(it)[0];
          obj[key] = it[key];
        });
        return Object.keys(obj).map(size => `${size} ${formatPrice(obj[size])}`).join(' | ');
      }
    } catch (e) {}

    return formatPrice(d.itemPrice);
  }

  return <div className={'changes'}>
    <header>
      <h2>Review updated items</h2>
    </header>

    <section>
      {updates.map((it, idx) => <div key={it.id} className={'entry'} onClick={() => toggleSelected(it.id!!)}>
        <div>
          <Checkbox checked={!!selected.find(s => s === it.id)}/>
        </div>
        <div className={'details'}>
          <span className={'title'}>{it.itemName}</span>
          <span className={'description'} dangerouslySetInnerHTML={{__html: (it.itemDescription?.replace('\n', '<br/>') || '')}}></span>
          <span className={'price'}>{getPrice(it)}</span>
        </div>
      </div>)}
    </section>

    <footer>
      <Button type={'Primary'} inverted onClick={approveSelected} disabled={!selected.length}>Approve Selected</Button>
      <Button type={'Primary'} onClick={approveAll}>Approve all</Button>
    </footer>
  </div>
}
